/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import {
  useColorModeValue,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Icon,
  Text,
  Image,
  Avatar,
} from '@chakra-ui/react';
import { BiImageAdd } from 'react-icons/bi';
import { FieldValues, UseFormRegister } from 'react-hook-form';
import { handleImgError } from '../../../../utils/HandleFunctions';

interface ImageInputFormProps {
  defaultVal: any;
  setImages: (image: any) => void;
  setIsUpping: (state: boolean) => void;
  name: string | undefined | any;
  label: string | undefined;
  useAvatar?: boolean;
  isRequired?: boolean;
  register: UseFormRegister<FieldValues>;
  watch: any;
  errors: any;
}

export const ImageInputForm = ({
  defaultVal,
  setImages,
  setIsUpping,
  name,
  label,
  useAvatar = false,
  isRequired,
  register,
  watch,
  errors,
}: ImageInputFormProps) => {
  const [preview, setPreview] = useState<any>(undefined);

  const convert2base64 = file => {
    setIsUpping(true);
    const reader = new FileReader();
    reader.onloadend = () => {
      setImages(reader.result);
    };
    reader.readAsDataURL(file);
    setIsUpping(false);
  };

  useEffect(() => {
    if (watch(name)?.length > 0 && typeof watch(name) === 'object') {
      convert2base64(watch(name)[0] as any);
      const objectUrl = URL.createObjectURL(watch(name)[0]);
      setPreview(objectUrl);

      return () => URL.revokeObjectURL(objectUrl);
    }
    setPreview(undefined);
  }, [watch(name)]);

  return (
    <FormControl isRequired={isRequired} isInvalid={!!errors[name]} mb={5}>
      <FormLabel fontWeight="bold" mb={2} htmlFor={name}>
        {label}
      </FormLabel>

      {useAvatar ? (
        <Avatar
          mb="15px"
          boxShadow="0px 3px 6px #00000065"
          w="200px"
          h="200px"
          src={preview ?? defaultVal?.original}
        />
      ) : (
        (defaultVal?.original || preview) && (
          <Image
            mb="15px"
            boxShadow="0px 3px 6px #00000065"
            borderRadius="10px"
            w="150px"
            onError={handleImgError}
            src={preview ?? defaultVal?.original}
          />
        )
      )}
      <label htmlFor={name} style={{ display: 'block', width: '200px' }}>
        <Flex
          w="200px"
          h="40px"
          p="5px"
          bg={useColorModeValue('theme.light.bodyInput', 'theme.dark.bodyInput')}
          cursor="pointer"
          transition="0.2s ease"
          align="center"
          justify="center"
          borderRadius="5px"
          _hover={{ opacity: 0.6 }}
          textTransform="uppercase"
          boxShadow="0px 2px 4px #00000050"
        >
          <Icon as={BiImageAdd} mr="5px" fontSize="25px" />
          <Text fontWeight="bold">{useAvatar ? 'Alterar foto' : 'Escolher imagem'}</Text>
        </Flex>
      </label>
      <input id={name} type="file" hidden accept="image/*" {...register(name)} />
      {errors[name] && <FormErrorMessage>{errors[name]?.message}</FormErrorMessage>}
    </FormControl>
  );
};
